import {Tab, TabsNavigation} from 'pepsico-ds'
import React from 'react'

type Props = {
  selectedTabIndex: number
  onTabChange: (index: number) => void
  tabs: Array<{key: string; label: string}>
}

export default function TabsNav({selectedTabIndex, onTabChange, tabs}: Props): React.JSX.Element {
  return (
    <TabsNavigation selectedIndex={selectedTabIndex} onUpdate={onTabChange}>
      {tabs.map(tab => (
        <Tab key={tab.key} label={tab.label} />
      ))}
    </TabsNavigation>
  )
}
